import { deepMerge } from '../../utils';
import { TypographyBaseFontSize, TypographyBaseLineHeight, TypographyFamilyBodyFontFamily, TypographyFamilyBodyFontWeightBold, TypographyFamilyBodyFontWeightDefault, TypographyFamilyBodyFontWeightSemiBold, TypographyFamilyCaptionFontFamily, TypographyFamilyCaptionFontWeightBold, TypographyFamilyCaptionFontWeightDefault, TypographyFamilyCaptionFontWeightSemiBold, TypographyFamilyHeadingFontFamily, TypographyFamilyHeadingFontWeightDefault, TypographyFamilyHeroFontFamily, TypographyFamilyHeroFontWeightDefault, TypographyFamilyPriceFontFamily, TypographyFamilyPriceFontWeightDefault, TypographyLineHeightL, TypographyLineHeightM, TypographyLineHeightS, TypographyLineHeightXs } from '../../design-tokens/honeycomb-tokens';
const defaultLineHeights = {
  xs: TypographyLineHeightXs,
  s: TypographyLineHeightS,
  m: TypographyLineHeightM,
  l: TypographyLineHeightL
}; // Families

const defaultFamilyBody = {
  fontFamily: TypographyFamilyBodyFontFamily,
  fontWeight: {
    default: TypographyFamilyBodyFontWeightDefault,
    regular: TypographyFamilyBodyFontWeightDefault,
    semiBold: TypographyFamilyBodyFontWeightSemiBold,
    bold: TypographyFamilyBodyFontWeightBold
  },
  textTransform: 'none'
};
const defaultFamilyHeading = {
  fontFamily: TypographyFamilyHeadingFontFamily,
  fontWeight: {
    default: TypographyFamilyHeadingFontWeightDefault
  },
  textTransform: 'none'
};
const defaultFamilyHero = {
  fontFamily: TypographyFamilyHeroFontFamily,
  fontWeight: {
    default: TypographyFamilyHeroFontWeightDefault
  },
  textTransform: 'none'
};
const defaultFamilyPrice = {
  fontFamily: TypographyFamilyPriceFontFamily,
  fontWeight: {
    default: TypographyFamilyPriceFontWeightDefault
  },
  textTransform: 'none'
};
const defaultFamilyCaption = {
  fontFamily: TypographyFamilyCaptionFontFamily,
  fontWeight: {
    default: TypographyFamilyCaptionFontWeightDefault,
    regular: TypographyFamilyCaptionFontWeightDefault,
    semiBold: TypographyFamilyCaptionFontWeightSemiBold,
    bold: TypographyFamilyCaptionFontWeightBold
  },
  textTransform: 'none'
}; // Body

const defaultVariantBodyXs = {
  xs: {
    fontSize: '0.75rem',
    // 12px
    lineHeight: '1.125rem',
    // 18px
    letterSpacing: 'normal'
  },
  m: {
    fontSize: '0.75rem',
    // 12px
    lineHeight: '1.125rem',
    // 18px
    letterSpacing: 'normal'
  },
  l: {
    fontSize: '0.75rem',
    // 12px
    lineHeight: '1.125rem',
    // 18px
    letterSpacing: 'normal'
  }
};
const defaultVariantBodyS = {
  xs: {
    fontSize: '0.875rem',
    // 14px
    lineHeight: '1.25rem',
    // 20px
    letterSpacing: 'normal'
  },
  m: {
    fontSize: '0.875rem',
    // 14px
    lineHeight: '1.25rem',
    // 20px
    letterSpacing: 'normal'
  },
  l: {
    fontSize: '0.875rem',
    // 14px
    lineHeight: '1.25rem',
    // 20px
    letterSpacing: 'normal'
  }
};
const defaultVariantBodyM = {
  xs: {
    fontSize: '1rem',
    // 16px
    lineHeight: '1.5rem',
    // 24px
    letterSpacing: 'normal'
  },
  m: {
    fontSize: '1rem',
    // 16px
    lineHeight: '1.5rem',
    // 24px
    letterSpacing: 'normal'
  },
  l: {
    fontSize: '1rem',
    // 16px
    lineHeight: '1.5rem',
    // 24px
    letterSpacing: 'normal'
  }
};
const defaultVariantBodyL = {
  xs: {
    fontSize: '1rem',
    // 16px
    lineHeight: '1.5rem',
    // 24px
    letterSpacing: 'normal'
  },
  m: {
    fontSize: '1.125rem',
    // 18px
    lineHeight: '1.75rem',
    // 28px
    letterSpacing: 'normal'
  },
  l: {
    fontSize: '1.125rem',
    // 18px
    lineHeight: '1.75rem',
    // 28px
    letterSpacing: 'normal'
  }
};
const defaultVariantBodyXl = {
  xs: {
    fontSize: '1rem',
    // 16px
    lineHeight: '1.5rem',
    // 24px
    letterSpacing: 'normal'
  },
  m: {
    fontSize: '1.125rem',
    // 18px
    lineHeight: '1.75rem',
    // 28px
    letterSpacing: 'normal'
  },
  l: {
    fontSize: '1.25rem',
    // 20px
    lineHeight: '1.75rem',
    // 28px
    letterSpacing: 'normal'
  }
};
const defaultVariantBody2xl = {
  xs: {
    fontSize: '1rem',
    // 16px
    lineHeight: '1.5rem',
    // 24px
    letterSpacing: 'normal'
  },
  m: {
    fontSize: '1.125rem',
    // 18px
    lineHeight: '1.75rem',
    // 28px
    letterSpacing: 'normal'
  },
  l: {
    fontSize: '1.375rem',
    // 22px
    lineHeight: '2rem',
    // 32px
    letterSpacing: 'normal'
  }
};
const defaultVariantBody3xl = {
  xs: {
    fontSize: '1rem',
    // 16px
    lineHeight: '1.5rem',
    // 24px
    letterSpacing: 'normal'
  },
  m: {
    fontSize: '1.125rem',
    // 18px
    lineHeight: '1.75rem',
    // 28px
    letterSpacing: 'normal'
  },
  l: {
    fontSize: '1.5rem',
    // 24px
    lineHeight: '2rem',
    // 32px
    letterSpacing: 'normal'
  }
}; // Heading

const defaultVariantHeading2Xs = {
  xs: {
    fontSize: '0.875rem',
    // 14px
    lineHeight: '1.125rem',
    // 18px
    letterSpacing: 'normal'
  },
  m: {
    fontSize: '0.875rem',
    // 14px
    lineHeight: '1.125rem',
    // 18px
    letterSpacing: 'normal'
  },
  l: {
    fontSize: '0.875rem',
    // 14px
    lineHeight: '1.125rem',
    // 18px
    letterSpacing: 'normal'
  }
};
const defaultVariantHeadingXs = {
  xs: {
    fontSize: '1rem',
    // 16px
    lineHeight: '1.25rem',
    // 20px
    letterSpacing: 'normal'
  },
  m: {
    fontSize: '1rem',
    // 16px
    lineHeight: '1.25rem',
    // 20px
    letterSpacing: 'normal'
  },
  l: {
    fontSize: '1rem',
    // 16px
    lineHeight: '1.25rem',
    // 20px
    letterSpacing: 'normal'
  }
};
const defaultVariantHeadingS = {
  xs: {
    fontSize: '1.125rem',
    // 18px
    lineHeight: '1.5rem',
    // 24px
    letterSpacing: 'normal'
  },
  m: {
    fontSize: '1.125rem',
    // 18px
    lineHeight: '1.5rem',
    // 24px
    letterSpacing: 'normal'
  },
  l: {
    fontSize: '1.125rem',
    // 18px
    lineHeight: '1.5rem',
    // 24px
    letterSpacing: 'normal'
  }
};
const defaultVariantHeadingM = {
  xs: {
    fontSize: '1.5rem',
    // 24px
    lineHeight: '2rem',
    // 32px
    letterSpacing: 'normal'
  },
  m: {
    fontSize: '1.5rem',
    // 24px
    lineHeight: '2rem',
    // 32px
    letterSpacing: 'normal'
  },
  l: {
    fontSize: '1.5rem',
    // 24px
    lineHeight: '2rem',
    // 32px
    letterSpacing: 'normal'
  }
};
const defaultVariantHeadingL = {
  xs: {
    fontSize: '1.75rem',
    // 28px
    lineHeight: '2rem',
    // 32px
    letterSpacing: 'normal'
  },
  m: {
    fontSize: '1.75rem',
    // 28px
    lineHeight: '2rem',
    // 32px
    letterSpacing: 'normal'
  },
  l: {
    fontSize: '1.75rem',
    // 28px
    lineHeight: '2rem',
    // 32px
    letterSpacing: 'normal'
  }
};
const defaultVariantHeadingXl = {
  xs: {
    fontSize: '1.75rem',
    // 28px
    lineHeight: '2rem',
    // 32px
    letterSpacing: 'normal'
  },
  m: {
    fontSize: '2rem',
    // 32px
    lineHeight: '2rem',
    // 32px
    letterSpacing: 'normal'
  },
  l: {
    fontSize: '2rem',
    // 32px
    lineHeight: '2.25rem',
    // 36px
    letterSpacing: 'normal'
  }
}; // Hero

const defaultVariantHeroXs = {
  xs: {
    fontSize: '1.125rem',
    // 18px
    lineHeight: 1,
    // 18px
    letterSpacing: 'normal'
  },
  m: {
    fontSize: '1.125rem',
    // 18px
    lineHeight: 1,
    // 18px
    letterSpacing: 'normal'
  },
  l: {
    fontSize: '1.125rem',
    // 18px
    lineHeight: 1,
    // 18px
    letterSpacing: 'normal'
  }
};
const defaultVariantHeroS = {
  xs: {
    fontSize: '1.5rem',
    // 24px
    lineHeight: 1,
    // 24px
    letterSpacing: 'normal'
  },
  m: {
    fontSize: '1.5rem',
    // 24px
    lineHeight: 1,
    // 24px
    letterSpacing: 'normal'
  },
  l: {
    fontSize: '1.5rem',
    // 24px
    lineHeight: 1,
    // 24px
    letterSpacing: 'normal'
  }
};
const defaultVariantHeroM = {
  xs: {
    fontSize: '1.75rem',
    // 28px
    lineHeight: 1,
    // 28px
    letterSpacing: 'normal'
  },
  m: {
    fontSize: '1.75rem',
    // 28px
    lineHeight: 1,
    // 28px
    letterSpacing: 'normal'
  },
  l: {
    fontSize: '1.75rem',
    // 28px
    lineHeight: 1,
    // 28px
    letterSpacing: 'normal'
  }
};
const defaultVariantHeroL = {
  xs: {
    fontSize: '2rem',
    // 32px
    lineHeight: 1,
    // 32px
    letterSpacing: 'normal'
  },
  m: {
    fontSize: '2rem',
    // 32px
    lineHeight: 1,
    // 32px
    letterSpacing: 'normal'
  },
  l: {
    fontSize: '2rem',
    // 32px
    lineHeight: 1,
    // 32px
    letterSpacing: 'normal'
  }
};
const defaultVariantHeroXl = {
  xs: {
    fontSize: '2rem',
    // 32px
    lineHeight: 1,
    // 32px
    letterSpacing: 'normal'
  },
  m: {
    fontSize: '2.25rem',
    // 36px
    lineHeight: 1,
    // 36px
    letterSpacing: 'normal'
  },
  l: {
    fontSize: '2.25rem',
    // 36px
    lineHeight: 1,
    // 36px
    letterSpacing: 'normal'
  }
};
const defaultVariantHero2xl = {
  xs: {
    fontSize: '2rem',
    // 32px
    lineHeight: 1,
    // 32px
    letterSpacing: 'normal'
  },
  m: {
    fontSize: '2.25rem',
    // 36px
    lineHeight: 1,
    // 36px
    letterSpacing: 'normal'
  },
  l: {
    fontSize: '2.5rem',
    // 40px
    lineHeight: 1,
    // 40px
    letterSpacing: 'normal'
  }
};
const defaultVariantHero3xl = {
  xs: {
    fontSize: '2.5rem',
    // 40px
    lineHeight: 1,
    // 40px
    letterSpacing: 'normal'
  },
  m: {
    fontSize: '3rem',
    // 48px
    lineHeight: 1,
    // 48px
    letterSpacing: 'normal'
  },
  l: {
    fontSize: '3.5rem',
    // 56px
    lineHeight: 1,
    // 56px
    letterSpacing: 'normal'
  }
}; // Price

const defaultVariantPrice2xs = {
  xs: {
    fontSize: '1rem',
    // 16px
    lineHeight: 1,
    // 16px
    letterSpacing: 'normal'
  },
  m: {
    fontSize: '1rem',
    // 16px
    lineHeight: 1,
    // 16px
    letterSpacing: 'normal'
  },
  l: {
    fontSize: '1rem',
    // 16px
    lineHeight: 1,
    // 16px
    letterSpacing: 'normal'
  }
};
const defaultVariantPriceXs = {
  xs: {
    fontSize: '1.125rem',
    // 18px
    lineHeight: 1,
    // 18px
    letterSpacing: 'normal'
  },
  m: {
    fontSize: '1.125rem',
    // 18px
    lineHeight: 1,
    // 18px
    letterSpacing: 'normal'
  },
  l: {
    fontSize: '1.125rem',
    // 18px
    lineHeight: 1,
    // 18px
    letterSpacing: 'normal'
  }
};
const defaultVariantPriceS = {
  xs: {
    fontSize: '1.25rem',
    // 20px
    lineHeight: 1,
    // 20px
    letterSpacing: 'normal'
  },
  m: {
    fontSize: '1.25rem',
    // 20px
    lineHeight: 1,
    // 20px
    letterSpacing: 'normal'
  },
  l: {
    fontSize: '1.25rem',
    // 20px
    lineHeight: 1,
    // 20px
    letterSpacing: 'normal'
  }
};
const defaultVariantPriceM = {
  xs: {
    fontSize: '1.5rem',
    // 24px
    lineHeight: 1,
    // 24px
    letterSpacing: 'normal'
  },
  m: {
    fontSize: '1.5rem',
    // 24px
    lineHeight: 1,
    // 24px
    letterSpacing: 'normal'
  },
  l: {
    fontSize: '1.5rem',
    // 24px
    lineHeight: 1,
    // 24px
    letterSpacing: 'normal'
  }
};
const defaultVariantPriceL = {
  xs: {
    fontSize: '1.75rem',
    // 28px
    lineHeight: 1,
    // 28px
    letterSpacing: 'normal'
  },
  m: {
    fontSize: '2rem',
    // 32px
    lineHeight: 1,
    // 32px
    letterSpacing: 'normal'
  },
  l: {
    fontSize: '2rem',
    // 32px
    lineHeight: 1,
    // 32px
    letterSpacing: 'normal'
  }
};
const defaultVariantPriceXl = {
  xs: {
    fontSize: '2rem',
    // 32px
    lineHeight: 1,
    // 32px
    letterSpacing: 'normal'
  },
  m: {
    fontSize: '2.25rem',
    // 36px
    lineHeight: 1,
    // 36px
    letterSpacing: 'normal'
  },
  l: {
    fontSize: '2.5rem',
    // 40px
    lineHeight: 1,
    // 40px
    letterSpacing: 'normal'
  }
};
const defaultOverlayTextShadow = '0 2px 4px rgba(0, 0, 0, 0.6)';
const DEFAULT_TYPOGRAPHY = {
  baseFontSize: TypographyBaseFontSize,
  baseLineHeight: TypographyBaseLineHeight,
  lineHeight: defaultLineHeights,
  overlayTextShadow: defaultOverlayTextShadow,
  family: {
    body: defaultFamilyBody,
    heading: defaultFamilyHeading,
    hero: defaultFamilyHero,
    price: defaultFamilyPrice,
    caption: defaultFamilyCaption
  },
  variant: {
    body: {
      xs: defaultVariantBodyXs,
      s: defaultVariantBodyS,
      m: defaultVariantBodyM,
      l: defaultVariantBodyL,
      xl: defaultVariantBodyXl,
      '2xl': defaultVariantBody2xl,
      '3xl': defaultVariantBody3xl
    },
    heading: {
      '2xs': defaultVariantHeading2Xs,
      xs: defaultVariantHeadingXs,
      s: defaultVariantHeadingS,
      m: defaultVariantHeadingM,
      l: defaultVariantHeadingL,
      xl: defaultVariantHeadingXl
    },
    hero: {
      xs: defaultVariantHeroXs,
      s: defaultVariantHeroS,
      m: defaultVariantHeroM,
      l: defaultVariantHeroL,
      xl: defaultVariantHeroXl,
      '2xl': defaultVariantHero2xl,
      '3xl': defaultVariantHero3xl
    },
    price: {
      '2xs': defaultVariantPrice2xs,
      xs: defaultVariantPriceXs,
      s: defaultVariantPriceS,
      m: defaultVariantPriceM,
      l: defaultVariantPriceL,
      xl: defaultVariantPriceXl
    }
  }
};
export function createTypography(overrides) {
  return deepMerge(DEFAULT_TYPOGRAPHY, overrides);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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